/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`in ${i?.days} days`)
};

const es_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`en ${i?.days} días`)
};

const de_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`in ${i?.days} Tagen`)
};

const nl_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`over ${i?.days} dagen`)
};

const fr_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`dans ${i?.days} jours`)
};

const it_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`tra ${i?.days} giorni`)
};

const pt_br2_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`em ${i?.days} dias`)
};

const pt_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`em ${i?.days} dias`)
};

const ja_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}日後`)
};

const zh_age_in_days = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`还有 ${i?.days} 天`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ days: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_in_days = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_in_days(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_in_days", locale)
	if (locale === "en") return en_age_in_days(inputs)
	if (locale === "es") return es_age_in_days(inputs)
	if (locale === "de") return de_age_in_days(inputs)
	if (locale === "nl") return nl_age_in_days(inputs)
	if (locale === "fr") return fr_age_in_days(inputs)
	if (locale === "it") return it_age_in_days(inputs)
	if (locale === "pt-BR") return pt_br2_age_in_days(inputs)
	if (locale === "pt") return pt_age_in_days(inputs)
	if (locale === "ja") return ja_age_in_days(inputs)
	return zh_age_in_days(inputs)
};